<template>
	<v-form
		ref="form"
		v-model="ui.valid"
		lazy-validation
		@submit.prevent="login()"
	>
		<v-row>
			<v-col cols="12 mb-8">
				<h1>
					Iniciar sesión
				</h1>

				<span>
					¿No tiene cuenta?
					<router-link :to="{ name: 'Register' }">
						Crear cuenta
					</router-link>
				</span>
			</v-col>

			<v-col cols="12" class="pb-0 pt-0">
				<v-text-field
					clearable
					outlined
					label="Correo electrónico"
					:rules="[v.required, v.email]"
					v-model="layout.credentials.email"
					@keydown.enter="login()"
				></v-text-field>
			</v-col>
			<v-col cols="12" class="pb-0 pt-0">
				<v-text-field
					clearable
					outlined
					label="Contraseña"
					:rules="[v.required]"
					v-model="layout.credentials.password"
					:type="ui.showPassword ? 'text' : 'password'"
					:append-icon="ui.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
					@click:append="ui.showPassword = !ui.showPassword"
					@keydown.enter="login()"
				></v-text-field>
			</v-col>

			<v-col cols="12" md="4">
				<v-btn
					color="primary"
					large
					@click="login()"
					:disabled="!ui.valid"
					:loading="ui.storing"
					:block="$vuetify.breakpoint.smAndDown"
				>
					enviar
				</v-btn>
			</v-col>

			<v-col cols="12" md="8" class="d-flex justify-end align-start">
				¿Olvidó su contraseña?
				<router-link class="ml-2" :to="{ name: 'PasswordRestore' }">
					Recuperar contraseña
				</router-link>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
import { EventBus } from "@/main";
import axios from "axios";
import Validations from "@/../../GeneralComponents/Validations";

export default {
	name: "Login",

	data() {
		return {
			v: Validations,

			layout: {
				typeAuth: "user/password",
				credentials: {
					// email: "soporte@pinturasacuario.com",
					// password: "mxn2021",
					// email: "cliente01@pinturasacuario.mx",
					// password: "Acuario123",

					email: null,
					password: null,
				},
			},

			ui: {
				valid: true,
				storing: false,
				showPassword: false,
			},
		};
	},

	methods: {
		async login() {
			if (this.$refs.form.validate()) {
				try {
					this.ui.storing = true;

					let response = await axios.post(
						`${process.env.VUE_APP_API_SERVER}/auth/login`,
						this.layout
					);

					localStorage.setItem(
						"session",
						JSON.stringify(response.data.data)
					);

					await this.$store.dispatch("startApp");

					if (this.hasRol(1)) {
						this.$router.push({ name: "PerfilAdmin" });
					} else if (this.hasRol(6)) {
						this.$router.push({ name: "PerfilCliente" });
					} else {
						EventBus.$emit("Error", {
							error: "Error",
							subtitle: "Unauthorized",
							message:
								"Sorry, you are not authorized to access this resource.",
							errorsShow: true,
						});

						await this.$store.dispatch("logout");
					}
				} catch (error) {
					EventBus.$emit("Error", { error: error, errorsShow: true });
				} finally {
					this.ui.storing = false;
				}
			}
		},

		hasRol(rolIdRequired) {
			if (this.$store.state.authenticated) {
				if (
					this.$store.state.acount.user.roles.find(
						(rol) => rol.id === rolIdRequired
					)
				) {
					return true;
				}
			}

			return false;
		},
	},
};
</script>

<style lang="css" scoped></style>
